import { categoryApi } from '../../apis/CategoryApi';
import SinglePage from '../../components/About/SinglePage';
import Layout from '../../components/Layout';

const Home = (props) => {
   return (
      <Layout
         title="AWARDS - DNAP ARCHITECTURE"
         {...props}
         WrappedComponent={SinglePage}
         pageName="awards"
      />
   )
}

export async function getServerSideProps({ req }) {
   let isMobileView = (req
      ? req.headers['user-agent']
      : navigator.userAgent).match(
         /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i
      );

   return {
      props: {
         isMobileView: Boolean(isMobileView),
      }
   }
}

export default Home;
